{
  "markread": "Alles gelesen",
  "newest": "Neueste",
  "unread": "Ungelesen",
  "starred": "Favoriten",
  "tags": "Markierungen",
  "alltags": "Alle Markierungen",
  "timestamp": "{0,date} {0,time}",
  "hours": "vor {0,plural,one {1 Stunde},other {# Stunden}}",
  "minutes": "vor {0,plural,one {1 Minute},other {# Minuten}}",
  "seconds": "{0,plural,one {Jetzt gerade},other {vor # Sekunden}}",
  "days": "{0,plural,zero {heute},one {gestern},other {vor # Tagen}}",
  "star": "behalten",
  "unstar": "vergessen",
  "mark": "als gelesen markieren",
  "unmark": "als ungelesen markieren",
  "load_img": "Zeige Bilder",
  "open_window": "öffnen",
  "next": "weiter",
  "searchbutton": "suchen",
  "refreshbutton": "Quellen aktualisieren",
  "settingsbutton": "Einstellungen",
  "logoutbutton": "Abmelden",
  "loginbutton": "Anmelden",
  "sources": "Quellen",
  "source_add": "Quelle hinzufügen",
  "source_opml": "oder OPML-Datei oder Google Reader importieren",
  "source_export": "Quellen exportieren",
  "source_edit": "bearbeiten",
  "source_filter": "Filter",
  "source_delete": "löschen",
  "source_warn": "Wirklich diesen Feed entfernen?",
  "source_new": "Neue ungespeicherte Quelle",
  "source_title": "Titel",
  "source_autotitle_hint": "Leer lassen um automatisch Titel zu setzen",
  "source_tags": "Markierungen",
  "source_pwd_placeholder": "Nicht geändert",
  "source_comma": "Komma getrennt",
  "source_select": "Quelle auswählen",
  "source_type": "Typ",
  "source_save": "speichern",
  "source_cancel": "abbrechen",
  "source_saved": "gespeichert",
  "source_last_post": "Letzter gesehener Beitrag",
  "no_entries": "keine Einträge gefunden",
  "more": "mehr",
  "login": "Anmelden",
  "login_username": "Benutzername",
  "login_password": "Passwort",
  "no_title": "kein Titel",
  "error": "Ein Fehler ist aufgetreten",
  "filter": "Filter",
  "online_count": "Auf dem Server verfügbare Elemente",
  "offline_count": "Lokal verfügbare Artikel",
  "searchremove": "Suche ausblenden",
  "source_refresh": "Diese Quelle aktualisieren",
  "login_invalid_credentials": "Falscher Benutzername/Passwort",
  "login_offline": "Offline-Speicherung",
  "streamerror": "Keine Artikel geladen, neu laden?",
  "reload_list": "Liste neu laden",
  "sources_refreshed": "Quellen aktualisiert",
  "app_update": "selfoss wurde aktualisiert, bitte neu laden",
  "app_reload": "Neu laden",
  "error_session_expired": "Session abgelaufen",
  "error_add_source": "Die Quelle konnte nicht hinzugefügt werden:",
  "error_delete_source": "Die Quelle konnte nicht gelöscht werden:",
  "error_load_tags": "Konnte Markierungen nicht laden:",
  "error_unknown_tag": "Unbekannte Markierung:",
  "error_unknown_source": "Unbekannte Quell-ID:",
  "error_mark_items": "Es können nicht alle sichtbaren Elemente markiert werden:",
  "error_mark_item": "Das Markieren/Deaktivieren von Elementen ist nicht möglich:",
  "error_star_item": "Artikel kann nicht ge-sternt oder ent-sternt werden:",
  "error_logout": "Konnte nicht ausloggen:",
  "error_loading": "Ladefehler:",
  "error_loading_stats": "Nav-Statistiken können nicht geladen werden:",
  "error_saving_color": "Neue Farbe kann nicht gespeichert werden:",
  "error_refreshing_source": "Quellen können nicht aktualisiert werden:",
  "error_sync": "Letzte Änderungen vom Server konnten nicht synchronisiert werden:",
  "error_offline_storage": "Offline-Speicherfehler: {0}. Neu laden könnte helfen. Deaktiviere offline vorerst.",
  "error_invalid_subsection": "Ungültiger Unterabschnitt:",
  "search_label": "Suchbegriff",
  "article_actions": "Aktionen",
  "error_configuration": "Nicht möglich die Konfiguration zu laden.",
  "info_url_copied": "URL in die Zwischenablage kopiert.",
  "share_native_label": "teilen",
  "share_diaspora_label": "auf Diaspora teilen",
  "share_twitter_label": "auf Twitter teilen",
  "share_facebook_label": "auf Facebook teilen",
  "share_mastodon_label": "auf Mastodon teilen",
  "share_pocket_label": "in Pocket speichern",
  "share_wallabag_label": "in Wallabag speichern",
  "share_wordpress_label": "teile auf WordPress",
  "share_mail_label": "per E-Mail teilen",
  "share_copy_label": "Link in die Zwischenablage kopieren",
  "error_share_native_abort": "Es ist nicht möglich das Objekt zu teilen – entweder gibt es keine Ziele zum Teilen oder die Aktion wurde abgebrochen.",
  "error_share_native": "Es ist nicht möglich das Objekt zu teilen.",
  "close_entry": "Schließen",
  "error_offline_storage_not_available": "Offline-Speicherung ist nicht verfügbar. Stelle sicher, dass dein Browser die {0}IndexedDB-API unterstützt{1} und, falls du einen Browser auf Grundlage von Google Chrome benutzt, dass du selfoss nicht im Incognito-Modus ausführst.",
  "error_edit_source": "Konnte die Änderungen an den Quellen nicht speichern:",
  "error_unwritable_logs": "Logdateien konnten nicht geschrieben werden.",
  "error_check_system_logs": "Ein Fehler ist aufgetreten, bitte die Systemlogs prüfen.",
  "error_check_log_file": "Es ist ein Fehler aufgetreten, bitte Protokolldatei „{0}“ prüfen.",
  "offline_navigation_unavailable": "Markierungen und Quellen zu wechseln wird derzeit im Offline-Modus nicht unterstützt."
}
